import { type Common } from '../common.js';
import {
  type WorkerActivityParams,
  type WorkerActivityResponse,
  type WorkerActivitySummaryResponse,
} from '../models/flow/admin.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/admin';

  constructor(common: Common) {
    this.common = common;
  }

  async getWorkerActivity(params?: WorkerActivityParams): Promise<WorkerActivityResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/worker-activity`, params);
    return await this.common.getJSON(url);
  }

  async getWorkerActivitySummary(params?: {
    organizationId?: string;
  }): Promise<WorkerActivitySummaryResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/worker-activity/summary`, params);
    return await this.common.getJSON(url);
  }
}
